import { render, staticRenderFns } from "./FormBank.vue?vue&type=template&id=fce61f2c&scoped=true&"
import script from "./FormBank.vue?vue&type=script&lang=js&"
export * from "./FormBank.vue?vue&type=script&lang=js&"
import style0 from "./FormBank.vue?vue&type=style&index=0&id=fce61f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce61f2c",
  null
  
)

export default component.exports